//#region [IMPORT]

// === THIRD-PARTY ===
import React, { createContext, useState, useEffect } from 'react';

// === API ===
import { onTaskMonitorStatus, removeListener, requestTaskMonitorStatus } from 'api/prokey/prokey.websocket';

//#endregion

//-----------------------------------------------------------------
export function useTaskMonitoring() {
  //-----------------------------------------------------------------

  //#region [VALUES]

  const [ is_monitoring , setIsMonitoring ] = useState( true );

  //#endregion

  //#region [EFFECT]

  useEffect( () => {
    //-----------------------------------------------------------------
    function handleTaskMonitoring( data ) {
      //-----------------------------------------------------------------
      setIsMonitoring( data.is_active );
    }

    onTaskMonitorStatus( handleTaskMonitoring );

    requestTaskMonitorStatus();

    return () => {
      removeListener( 'TASK-MONITORING', handleTaskMonitoring );
    };
  }, [] );

  //#endregion

  return [ is_monitoring ];
}